export default "Saml optænding og grene og byg i fællesskab jeres eget jægerstenalderbål! \n";